<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
        <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Applications</h2>
        <div class="d-flex justify-content-between align-items-center">
          <input type="text" class="form-control mb-3" placeholder="Search in applications..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('application')">Application</th>
              <th class="col-1" @click="toggleSort('domains')">Domains</th>
              <th class="col-1" @click="toggleSort('description')">Description</th>
              <th class="col-1" @click="toggleSort('hlsPrefix')">HLS prefix</th>
              <th class="col-1" @click="toggleSort('hlsSufix')">HLS sufix</th>
              <th class="col-1" @click="toggleSort('edgePort')">Edge port</th>
              <th class="col-1" @click="toggleSort('appName')">App name</th>
              <th class="col-1" @click="toggleSort('sport')">Sport</th>
              <th class="col-1" @click="toggleSort('vidictLicense')">Vidict license</th>
              <th class="col-1" @click="toggleSort('vidictSecret')">Vidict secret</th>
              <th class="col-1" @click="toggleSort('emailTemplates')">Email templates</th>
              <th class="col-1" @click="toggleSort('active')">Active</th>

              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.application">
              <td class="col-1 text-truncate" v-html="truncateText(config.application, 30)" @click="selectText" :data-text="config.application"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.domains, 30)" @click="selectText" :data-text="config.domains"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.description, 30)" @click="selectText" :data-text="config.description"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.hlsPrefix, 30)" @click="selectText" :data-text="config.hlsPrefix"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.hlsSufix, 30)" @click="selectText" :data-text="config.hlsSufix"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.edgePort, 30)" @click="selectText" :data-text="config.edgePort"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.appName, 30)" @click="selectText" :data-text="config.appName"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.sport, 30)" @click="selectText" :data-text="config.sport"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.vidictLicense, 30)" @click="selectText" :data-text="config.vidictLicense"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.vidictSecret, 30)" @click="selectText" :data-text="config.vidictSecret"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.emailTemplates, 30)" @click="selectText" :data-text="config.emailTemplates"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.active, 30)" @click="selectText" :data-text="config.active"></td>
              <td class="col-1 centered">
                <a role="button" class="procricket-btn" @click="editApplication(config)">
                  Edit
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";

export default {
  name: "Applications",
  components: {
    Header,
  },
  data() {
    return {
      searchText: '',
      ApplicationList: [],
      sortColumn: '',  // Add this property
      sortDirection: 'asc',
    };
  },
  computed: {
    filteredCouponsList() {
      const search = this.searchText.toString().toLowerCase().trim();
      let filteredList = this.ApplicationList.filter((config) => {
        return (
            (config.application && config.application.toString().toLowerCase().includes(search)) ||
            (config.domains && config.domains.toString().toLowerCase().includes(search)) ||
            (config.description && config.description.toString().toLowerCase().includes(search)) ||
            (config.hlsPrefix && config.hlsPrefix.toString().toLowerCase().includes(search)) ||
            (config.hlsSufix && config.hlsSufix.toString().toLowerCase().includes(search)) ||
            (config.edgePort && config.edgePort.toString().toLowerCase().includes(search)) ||
            (config.appName && config.appName.toString().toLowerCase().includes(search)) ||
            (config.sport && config.sport.toString().toLowerCase().includes(search)) ||
            (config.vidictLicense && config.vidictLicense.toString().toLowerCase().includes(search)) ||
            (config.vidictSecret && config.vidictSecret.toString().toLowerCase().includes(search)) ||
            (config.emailTemplates && config.emailTemplates.toString().toLowerCase().includes(search)) ||
            (config.active && config.active.toString().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn];
          const valueB = b[this.sortColumn];

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      return filteredList;
    },
    sortData() {
      return this.filteredCouponsList;
    },
  },
  created() {
    this.doLoadPlans();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    this.sortColumn = 'application';
  },
  methods: {
    doLoadPlans() {
      AdminService.getApplicationList().then((data) => {
        this.ApplicationList = data;
      }).catch((error) => {
        console.error("Error loading applications:", error);
      });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    truncateText(text, limit) {
      if (text === undefined || text ===null) {
        return null
      } else {
        return text.length > limit ? text.substring(0, limit) + '...' : text;
      }
    },
    redirectToCreate() {
      this.$router.push({ name: 'ApplicationCreate' }); // Navigate to the StripeEdit route without params
    },
    editApplication(config) {
      // emailTemplates can be a large JSON blob - keep it out of the URL (which has
      // length limits and shows up in browser history/logs) and hand it off via
      // sessionStorage instead. ApplicationEdit reads it back out on created().
      sessionStorage.setItem('applicationEditEmailTemplates', config.emailTemplates || '');
      this.$router.push({
        name: 'ApplicationEdit',
        params: {
          application: config.application,
          domains: config.domains,
          description: config.description,
          hlsPrefix: config.hlsPrefix,
          hlsSufix: config.hlsSufix,
          edgePort: config.edgePort,
          appName: config.appName,
          sport: config.sport,
          vidictLicense: config.vidictLicense,
          vidictSecret: config.vidictSecret,
          active: config.active
        }
      });
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    }
  },
};
</script>
<style src="../../assets/style.css">
</style>
